// import { AdminLayout } from "#layouts";
// import { InProgress } from "#UI";

// const CropPlanManagement = () => {
//   return (
//     <div>
//       <InProgress />
//     </div>
//   );
// };

// export default CropPlanManagement;

/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomModal,
  CustomSelector,
  CustomTable,
  CustomTextArea,
  RowAction,
} from "#components";
import { TableLayout } from "#layouts";
import { cropPlanTableHeader } from "#utils/seeds.js";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AdminRoutePath, WebRoutePath } from "#routes/routePath.jsx";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import globalConfig from "#constants/globalConfig.js";
import { truncateWords, UseDebounce, yearsOptions } from "#utils/helpers.js";
import useDelete from "#hooks/useDelete.js";
import CustomAlert from "../../components/CustomAlert";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { useFormik } from "formik";
import { addCropPlanInitialValues } from "#validations/initialValues.js";
import { addCropPlanValidationSchema } from "#validations/validationSchema.js";
import usePost from "#hooks/usePost.js";
import usePut from "#hooks/usePut.js";

const CropPlanManagement = ({ searchInputCropPlanList }) => {
  const nav = useNavigate();
  const GrowerId = JSON.parse(
    localStorage.getItem(globalConfig.ADMIN_GROWER_ID)
  );
  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });
  const [currentPage, setCurrentPage] = useState({
    cropPlanModelList: 1,
    cropPlanList: 1,
  });
  const [dataCount, setDataCount] = useState({
    cropPlanModelList: 10,
    cropPlanList: 10,
  });
  const [cropPlanDetail, setCropPlanDetail] = useState(null);
  const debouncedSearch = UseDebounce(searchInputCropPlanList);
  const {
    data: cropPlanListData,
    isLoading: isCropPlanLoading,
    refetch: cropPlanListRefetch,
  } = useGet(
    ENDPOINTS.CROP_PLANE_SEASON_LIST,
    [QUERY_KEYS.CROP_PLANE_SEASON_LIST_QUERY_KEY, debouncedSearch],
    {
      page: currentPage.cropPlanList,
      limit: dataCount.cropPlanList,
      growerId: GrowerId,
      search: searchInputCropPlanList,
    }
  );
  const {
    mutateAsync: deleteCropPlanMutateAsync,
    isLoading: isLoadingDeleteCropPlan,
  } = useDelete(
    ENDPOINTS.DELETE_SEASON_PLAN,
    QUERY_KEYS.DELETE_SEASON_PLAN_LIST_QUERY_KEY
  );
  const {
    mutateAsync: addCropPlanMutateAsync,
    isLoading: isLoadingAddCropPlan,
  } = usePost(ENDPOINTS.ADD_SEASON_PLAN, QUERY_KEYS.ADD_SEASON_PLAN_QUERY_KEY);
  const {
    mutateAsync: edtCropPlanMutateAsync,
    isLoading: isLoadingEditCropPlan,
  } = usePut(ENDPOINTS.EDIT_SEASON_PLAN, QUERY_KEYS.EDIT_SEASON_PLAN_QUERY_KEY);

  const cropPlanList = cropPlanListData?.data;

  const handleDeleteCropPlan = async (cropPlanId) => {
    CustomAlert({
      title: "Are you sure you want to delete the crop plan?",
      confirmButtonText: isLoadingDeleteCropPlan ? (
        <ClipLoader size={17} color="#fff" />
      ) : (
        "Confirm"
      ),
      icon: "question",
      onConfirm: async () => {
        try {
          const response = await deleteCropPlanMutateAsync({
            seasonId: cropPlanId,
          });
          AlertTost(response?.message, "success");
          cropPlanListRefetch();
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const handlePagination = (type, action) => {
    setCurrentPage((prev) => ({
      ...prev,
      [type]: action === "next" ? prev[type] + 1 : prev[type] - 1,
    }));
  };

  const handleDataCountChange = (type, value) => {
    setDataCount((prev) => ({ ...prev, [type]: value }));
    setCurrentPage((prev) => ({ ...prev, [type]: 1 }));
  };

  const exportPDF = () => {
    const doc = new jsPDF();

    // Add title
    doc.text("Crop Plan List", 10, 10);

    // Table Headers
    const headers = ["Growing Session", "Description", "Status"];

    // Table Data
    const data = cropPlanList?.list?.map((item) => [
      item.year,
      item.description,
      item.seasonType,
    ]);

    // Add table to PDF
    doc.autoTable({
      head: [headers],
      body: data,
    });

    // Save the PDF
    doc.save("CropPlanList.pdf");
  };
  const existingYears =
    cropPlanListData?.data?.list?.map((item) => item.year) || [];
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: addCropPlanInitialValues,
    validationSchema: addCropPlanValidationSchema(existingYears),

    onSubmit: async () => {
      try {
        const data = {
          growerId: GrowerId,
          year: values?.growingSeason,
          description: values?.description,
          // seasonType: values?.planStatus,
          seasonType: "Active",
          seasonId: cropPlanDetail?._id,
        };

        if (open.add) {
          try {
            const response = await addCropPlanMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            cropPlanListRefetch();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await edtCropPlanMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            cropPlanListRefetch();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });

  const onOpen = (key, data) => {
    setOpen({ ...open, [key]: true });
    setCropPlanDetail(data);
  };
  const handelAddCrop = (item) => {
    localStorage.setItem(globalConfig.SEASON_ID, item?._id);
    nav(AdminRoutePath?.CROP_PLAN_DETAIL?.path, {
      state: { data: item },
    });
  };
  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setCropPlanDetail(null);
    resetForm();
  };
  useEffect(() => {
    cropPlanListRefetch();
  }, [
    // searchInputCropPlanList,
    dataCount.cropPlanList,
    currentPage.cropPlanList,
  ]);

  useEffect(() => {
    if (open.edit) {
      setValues({
        growingSeason: cropPlanDetail?.year,
        description: cropPlanDetail?.description,
        planStatus: cropPlanDetail?.seasonType,
      });
    }
  }, [open.edit, cropPlanDetail]);

  // add crop  ------
  const renderModalData = () => (
    <div className="common-modal-form">
      <div className="row">
        <div className="col-xl-6">
          <CustomSelector
            label="Growing Season"
            options={yearsOptions()}
            defaultValue="Select"
            name="growingSeason"
            value={values.growingSeason}
            onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue("growingSeason", e.target.value);
            }}
            touched={touched.growingSeason}
            error={errors.growingSeason}
          />
        </div>
        {/* <div className="col-xl-6">
          <div className="row p-3">
            <div className="row">
              {["Template", "Active", "Historic"].map((label, idx) => (
                <div className="col-xl-4" key={idx}>
                  <div className="radio-btn-container">
                    <span>{label}</span>
                    <div className="radio_div">
                      <input
                        type="radio"
                        name="template"
                        id={`radio-${label}`}
                        value={label}
                        onChange={(e) => {
                          setFieldValue("planStatus", e.target.value);
                        }}
                        checked={values.planStatus === label}
                      />
                      <label htmlFor={`radio-${label}`}></label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
      <CustomTextArea
        label="Description"
        placeholder="Enter description here"
        name="description"
        value={values.description}
        onChange={handleChange}
        touched={touched.description}
        error={errors.description}
      />
    </div>
  );

  return (
    <div className="tab-pane fade show active">
      <div className="tab-content-wrapper">
        <div className="row">
          <div className="col-xl-12">
            <div className="sub-heading flex-box">
              <h2>Listing </h2>
              {/* <div className="side-content-blk">
                <div className="side-content-blk">
                  <button className="primary-outline-btn" onClick={exportPDF}>
                    <span className="outline_btn_icon">
                      <img
                        src="/assets/images/icons/export-csv-icon.svg"
                        alt="calc"
                      />
                    </span>
                    <span className="outline_btn_text">Export PDF</span>
                  </button>
                </div>
                <button className="primary-btn" onClick={() => onOpen("add")}>
                  Add Crop Plan
                </button>
              </div> */}
            </div>
            <div>
              <TableLayout
                tableHeader={cropPlanTableHeader}
                isEmpty={cropPlanList?.list?.length === 0}
                isLoading={isCropPlanLoading}
                currentPage={currentPage.cropPlanList}
                totalItems={cropPlanList?.totalItems}
                onDataCountChange={(e) =>
                  handleDataCountChange("cropPlanList", e.target.value)
                }
                handlePrevPage={() => handlePagination("cropPlanList", "prev")}
                handleNextPage={() => handlePagination("cropPlanList", "next")}
                rowLimit={dataCount.cropPlanList}
              >
                <CustomTable tableHeader={cropPlanTableHeader}>
                  {cropPlanList?.list?.map((item, index) => (
                    <tr className="cursor-pointer" key={index}>
                      <td
                        onClick={() =>
                          item.status === 0 ? handelAddCrop(item) : null
                        }
                      >
                        {item?.year}
                      </td>
                      <td
                        onClick={() =>
                          item.status === 0 ? handelAddCrop(item) : null
                        }
                      >
                        {truncateWords(item?.description)}
                      </td>
                      {/* <td
                        onClick={() =>
                          item.status === 0 ? handelAddCrop(item?._id) : null
                        }
                      >
                        <span
                          className={`table-status ${
                            item?.seasonType === "Active"
                              ? "st-active"
                              : item?.seasonType === "Template"
                              ? "st-template"
                              : "st-history"
                          }`}
                        >
                          {item?.seasonType === "Active"
                            ? "Active"
                            : item?.seasonType === "Template"
                            ? "Template"
                            : "Historic"}
                        </span>
                      </td> */}
                      <RowAction
                        activeAction={{
                          edit: false,
                          view: true,
                          delete: false,
                          status: false,
                        }}
                        onDelete={() => {
                          handleDeleteCropPlan(item?._id);
                        }}
                        onEdit={() => onOpen("edit", item)}
                        onView={() => {
                          localStorage.setItem(
                            globalConfig.ADMIN_SEASON_ID,
                            item?._id
                          );
                          nav(AdminRoutePath.CROP_PLAN_DETAIL.path);
                        }}
                      />
                    </tr>
                  ))}
                </CustomTable>
              </TableLayout>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add Crop Plan" : "Edit Crop Plan"}
        actionButtonTitle={open.add ? "Save" : "Update"}
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={handleSubmit}
        loading={isLoadingAddCropPlan || isLoadingEditCropPlan}
        bodyClass="modal-body p-0 border_structure"
      >
        {renderModalData()}
      </CustomModal>
    </div>
  );
};

export default CropPlanManagement;
